<div class="container-card">
  <div class="card">
    <div class="search-card-header">
      <div class="card-title">
        <h2 class="red-heading">{{ sectionTitle | uppercase }}</h2>
      </div>
      <div class="card-detail-button">
        <grid-button variant="secondary" gridId="{{ sectionTitle }}" (click)="titleEmitter($event)" #gridButton> Dettaglio </grid-button>
      </div>
    </div>
    <div class="search-card-body">
      <div class="row" *ngFor="let section of sectionSummary.data">
        <app-static-summary-data [sectionData]="sectionData" [singleSectionCardData]="section"></app-static-summary-data>
      </div>
    </div>
  </div>
</div>
